module.exports = __webpack_public_path__ + "img/onlinecare_jumbotron.6d840c46.png";